<template>
  <nav-bar v-if="!preview" class="transparent" title="咨询单详情" />
  <div class="answer" :class="{ 'no-bar': preview }">
    <h1>{{ detail.SurveyTitle }}</h1>
    <div v-if="detail.Survey" class="bd">
      <div v-for="(item, key) in detail.Survey" :key="key" class="answer-list">
        <div class="title">{{ key + 1 }}，{{ item.Title }}</div>
        <div class="content">
          <div v-if="item.QuestionType == 8" class="flex flex-wrap">
            <van-image
              v-for="(item2, index) in getFileList(item.Answer)"
              :key="index"
              fit="cover"
              height="100"
              :src="item2"
              width="100"
              @click="showImg(getFileList(item.Answer), index)"
            />
          </div>
          <div v-else>
            {{ getAnswer(item.Answer) || '（未填写）' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import store from '@/store'
  import { useRoute } from 'vue-router'
  import { ref } from 'vue'
  import api from '@/api'
  import { ImagePreview } from 'vant'
  import NavBar from '@/components/NavBar'
  import { wxShare } from '@/utils'
  export default {
    components: {
      NavBar,
    },
    setup(props, context) {
      const route = useRoute()
      const query = route.query
      const params = route.params
      const preview = ref(false)
      if (query.preview) {
        preview.value = true
      }
      let detail = ref({ Survey: [] })
      const getDetail = (async () => {
        let url = 'survey/FormQueryFormSurvey'
        const data = {}
        if (query.type === 'resultId') {
          url = 'survey/GetUserResult'
          data.resultId = params.id
        } else {
          data.FormId = params.id
        }
        store
          .dispatch(url, data)
          .then((data) => {
            const { Data } = data
            if (query.type === 'resultId') {
              detail.value.Survey = Data
            } else {
              detail.value = Data.CurrentPage[0]
            }
            wxShare('问卷详情', '请确认该问卷是不是您本人提交的。')
          })
          .catch((e) => {})
      })()

      const getAnswer = (item) => {
        let back = []
        back = item ? item : []
        return back.join(',')
      }

      const getFileList = (str) => {
        if (str && str.length) {
          const list = []
          str[0].split(',').forEach((item) => {
            list.push(api.FileHost + item)
          })
          return list
        }
      }

      const showImg = (list, index) => {
        ImagePreview({
          images: list,
          startPosition: index,
          showIndex: false,
          showIndicators: true,
          overlayStyle: {
            background: '#000',
          },
          //closeable: true,
        })
      }

      return { detail, getAnswer, getFileList, showImg, preview }
    },
  }
</script>
<style lang="scss" scoped>
  .answer {
    background: #5590ff;
    border: 1px solid #5590ff;
    padding: 54px 12px 12px;
    &.no-bar {
      padding-top: 0px;
      .bd {
        min-height: calc(100vh - 120px - 30px);
      }
    }
    h1 {
      font-size: 20px;
      text-align: center;
      margin: 20px 0;
      color: #fff;
    }
    .bd {
      background: #fff;
      border-radius: 4px;
      padding: 12px;
      min-height: calc(100vh - 44px - 120px - 80px);
    }
    .answer-list {
      margin-bottom: 16px;
      .title {
        color: #666;
        font-size: 16px;
      }
      .content {
        border-bottom: 1px solid #eee;
        font-size: 16px;
        padding: 10px 0 6px;
        text-indent: 22px;
        .van-image {
          margin: 4px;
        }
      }
    }
  }
</style>
